import { render, staticRenderFns } from "./RelatedCollection.vue?vue&type=template&id=a0b83c3e&scoped=true&"
import script from "./RelatedCollection.vue?vue&type=script&lang=js&"
export * from "./RelatedCollection.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCollection.vue?vue&type=style&index=0&id=a0b83c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b83c3e",
  null
  
)

export default component.exports